/* eslint-disable no-underscore-dangle */

import {
	LineController as BaseLineController,
} from 'chart.js';
import style from '../chart.scss';

export default class LineController extends BaseLineController {
	draw() {
		const { chart } = this;
		const meta = this._cachedMeta;

		if (
			chart.tooltip._active && chart.tooltip._active.length
			&& chart._metasets[[chart._metasets.length - 1]].label === meta._dataset.label
		) {
			const { ctx } = chart;
			const activePoint = chart.tooltip._active[0];
			const { x } = activePoint.element;
			const topY = chart.chartArea.top;
			const bottomY = chart.chartArea.bottom;

			// draw line
			ctx.save();
			ctx.beginPath();
			ctx.moveTo(x, topY);
			ctx.lineTo(x, bottomY);
			ctx.lineWidth = 1;
			ctx.strokeStyle = `${style['light-grid-zero']}`;
			ctx.setLineDash([10, 5]);
			ctx.stroke();
			ctx.restore();
		}

		meta.dataset.updateControlPoints(chart.chartArea, meta.iScale.axis);
		super.draw();
	}
}
